const invertedMessages = {
  Close: 'CloseLabel',
  Menu: 'CERTS_MENU',
  'Open Discovery Center': 'certs.open.discovery.center',
};

export default invertedMessages;
